import { jsx as _jsx } from "react/jsx-runtime";
export function VaniaGlassPanel({ children, elevated = false, style, ...props }) {
    const panelStyle = {
        border: '1px solid var(--color-border-subtle, var(--vania-border-glass, currentColor))',
        borderRadius: 'var(--vania-radius-lg, 16px)',
        background: elevated
            ? 'var(--color-surface-command, var(--vania-surface-2, transparent))'
            : 'var(--color-surface-glass, var(--vania-surface, transparent))',
        boxShadow: elevated ? 'var(--color-shadow-command, var(--vania-shadow-3, none))' : 'none',
        backdropFilter: 'blur(16px)',
        ...style,
    };
    return _jsx("div", { ...props, style: panelStyle, children: children });
}
